import React, { useState } from "react";
import SelectBox from "../../../components/SelectBox";
import {
  alertList,
  siteDetails,
  companyDetails,
} from "../../redux/api/dummyJson";

const AlertEscalation = ({
  selectedItem,
  setSelectedItem,
  site,
  setSite,
  comapanyList,
  getSiteList,
  siteList,
  getAlertTypes,
  setAlertData,
  alertData,
}) => {
  const [data, setData] = useState([]);

  const [company, setCompany] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState([]);

  console.log("company", selectedCompany);

  // Table data
  const [rows, setRows] = useState([
    {
      sno: 1,
      severity: 1,
      groups: "Group 1 → Group 2",
      time: 10,
    },
    {
      sno: 2,
      severity: 1,
      groups: "Group 2 → Group 3",
      time: 15,
    },
    {
      sno: 3,
      severity: 2,
      groups: "Group 1 → Group 2",
      time: 20,
    },
    {
      sno: 4,
      severity: 2,
      groups: "Group 2 → Group 3",
      time: 25,
    },
    {
      sno: 5,
      severity: 3,
      groups: "Group 1 → Group 2",
      time: 30,
    },
    {
      sno: 6,
      severity: 3,
      groups: "Group 2 → Group 3",
      time: 35,
    },
  ]);

  const [editIndex, setEditIndex] = useState(null);
  const [tempTime, setTempTime] = useState("");

  const handleEdit = (index) => {
    setEditIndex(index);
    setTempTime(rows[index].time);
  };

  const handleSave = (index) => {
    const updated = [...rows];
    updated[index].time = tempTime;
    setRows(updated);
    setEditIndex(null);
  };

  const handleCancel = () => {
    setEditIndex(null);
    setTempTime("");
  };

  return (
    <div className="dashRightView ">
      <div className="d-flex ac-jb">
        <h2 className="f3 fs-sm-16 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-26">
          Total: {site ? alertData.length : 0}
        </h2>

        <div className="d-flex ac-jc">
          <h2 className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-18 fs-xxl-20 primary">
            Select Company
          </h2>
          <SelectBox
            arrayData={comapanyList}
            data={company}
            setData={setCompany}
            selectedOption={selectedItem}
            setSelectedOption={getSiteList}
            isClearable={false}
          />
        </div>

        <div className="d-flex ac-jc">
          <h2 className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-18 fs-xxl-20 primary">
            Select Site
          </h2>
          <SelectBox
            arrayData={siteList}
            data={data}
            setData={setData}
            selectedOption={site}
            setSelectedOption={getAlertTypes}
            disabled={selectedItem?.label ? false : true}
          />
        </div>
      </div>

      {!site ? (
        <div className="d-flex ac-jc mt-5">
          <h2 className="f2 fs-sm-14 fs-md-18 fs-lg-20 fs-xl-22 fs-xxl-24 black">
            Select Site first
          </h2>
        </div>
      ) : (
        <table className="table table-bordered m-3">
          <thead>
            <tr className="text-center">
              <th>S.No</th>
              <th>Severity</th>
              <th>Groups</th>
              <th>Time (mins)</th>
              {/* <th>Actions</th> */}
            </tr>
          </thead>
          <tbody>
            {alertData?.map((row, i) => {
              const isEditing = editIndex === i;
              return (
                <tr key={i} className="text-center">
                  <td>{i + 1}</td>
                  <td>{row?.severity}</td>
                  <td className="text-nowrap">
                    {row?.from_group ? `Group  ${row?.from_group} ` : ""}
                    {row?.to_group ? `→ Group  ${row?.to_group}` : ""}
                  </td>
                  <td>
                    {isEditing ? (
                      <input
                        type="text"
                        value={tempTime}
                        onChange={(e) => setTempTime(e.target.value)}
                        className="input-box text-center w-50"
                      />
                    ) : (
                      <input
                        type="text"
                        value={row?.escalation_minutes}
                        disabled
                        className="input-box text-center w-50"
                      />
                    )}
                  </td>
                  {/* <td>
                                        {isEditing ? (
                                            <div div className='d-flex ac-jc gap-3'>
                                                <button
                                                    className="save-btn"
                                                    onClick={() => handleSave(i)}
                                                    style={{
                                                        height: '40px'
                                                    }}
                                                >
                                                    Save
                                                </button>
                                                <button
                                                    className="cancel-btn"
                                                    onClick={handleCancel}
                                                    style={{
                                                        height: '40px'
                                                    }}
                                                >
                                                    Cancel
                                                </button>
                                            </div>
                                        ) : (


                                            <button

                                                className="cust-btn "
                                                onClick={() => handleEdit(i)}
                                            >
                                                <img src={edit_icon} alt="" className=" edit-btn " />
                                            </button>
                                        )}
                                    </td> */}
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default AlertEscalation;
